'use strict';

import $ from 'jquery';
import ga from './../../vendor/google-analytics';

var Forms = (function() {
  return function() {
    var publicNS = {};

    publicNS.init = function() {
      $('body').on('submit', '#sumome-form', function() {
        ga('send', 'event', 'newsletter', 'SumoMe Submit', window.location.href);
        var $rpiRedirect = $('#rpiRedirect');
        $rpiRedirect.val('' +
          $rpiRedirect.val() +
          '?firstName=' + encodeURIComponent($('#first_name').val()) +
          '&lastName=' + encodeURIComponent($('#last_name').val()) +
          '&email=' + encodeURIComponent($('#EmailFieldName').val()));
      });
    };

    return publicNS;
  };
})();

export default new Forms();